import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('AccordionHeader', [
  'button',
  'chevron',
  'expanded',
  'positionEnd',
  'content',
  'labelGroup',
  'freeContent',
]);

export const getAccordionHeaderCss = css`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  z-index: 0;

  ${breakpoints.down('xs')} {
    flex-direction: column;
    align-items: stretch;
  }

  &:hover {
    background-color: var(
      --cds-color-interactive-background-primary-hover-weak
    );
    border-radius: var(--cds-border-radius-200);
  }

  .${classes.chevron} {
    flex-shrink: 0;
    color: var(--cds-color-neutral-primary);
    padding: 0;
    margin: 0 12px 0 0;
    transition-property: transform;
    transition-duration: 150ms;
    transition-timing-function: ease-in-out;
    transform: rotate(0deg);

    &.${classes.positionEnd} {
      margin: 0 0 0 12px;
    }

    &.${classes.expanded} {
      transform: rotate(180deg);
    }
  }

  .${classes.button} {
    text-align: inherit;
    padding: var(--cds-spacing-200);
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    z-index: 1;
  }

  .${classes.content} {
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    /* The chevron is 24px hight and it's anchored to the top. This aligns the content to the center of the chevron. */
    margin-top: 2px;

    ${breakpoints.down('xs')} {
      flex-direction: column;
    }
  }

  .${classes.labelGroup} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 1;
  }

  .${classes.freeContent} {
    padding-top: var(--cds-spacing-200);
    padding-inline-start: var(--cds-spacing-100);
    padding-inline-end: var(--cds-spacing-200);
    padding-bottom: 0;
    max-width: 50%;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-end;

    ${breakpoints.down('xs')} {
      justify-content: flex-start;
      padding: 0 var(--cds-spacing-200) var(--cds-spacing-200);
      max-width: 100%;
    }
  }
`;
